import * as React from 'react';
import TableCell from "@mui/material/TableCell";
import SelectAddressField from "./fields/SelectAddressField";
import SelectDriverField from "./fields/SelectDriverField";
import SelectVehicleField from "./fields/SelectVehicleField";
import {FormControlLabel, Stack, Table, TextField} from '@mui/material';
import {Cancel, CancelRounded, CheckRounded, CloseRounded, EditRounded} from "@mui/icons-material";
import Checkbox from "@mui/material/Checkbox";
import SelectStaffField from "./fields/SelectStaffField";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";

const SelectStaffCell = ({
                        rows,
                      }: {
  rows: any;
}) => {

  return (

    <Table
      sx={{
        width: '100%'
      }}
      aria-label="simple table"
    >
      <TableBody
        sx={{
          '& tr:last-child td, & tr:last-child th': {
            border: 0
          },
          ' .MuiTableCell-root': {
            padding: '2px',
          }
        }}
      >

        <TableRow>
          <TableCell component="th" scope="row">
            Fellépők:
          </TableCell>

          <TableCell
            sx={{
              '& .MuiAutocomplete-root .MuiOutlinedInput-root':{
                border: '1px solid #e3e3e3 !important'
              },
              '& .MuiOutlinedInput-notchedOutline':{
                border: '1px solid #e3e3e3 !important'
              }
            }}
          >

            {rows.map((row:any)=>{
              return (
                <>
                  <SelectStaffField
                    params={{
                      value: row?.selected_staff,
                      row: row
                    }}
                    type={'card'}
                    onChangeValue={(value) => {
                      //onChange(fieldKey, value);
                    }}
                  />
                </>
              );
            })}
          </TableCell>
        </TableRow>

      </TableBody>
    </Table>
  );
};

export default SelectStaffCell;


